import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_SIDEBAR } from 'config/constants/ui'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const Titlebar = ({ children }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const isSidebarGL = theme.tmpGlobalLayout === LAYOUT_SIDEBAR

   return (
      <View
         display="flex"
         justifyContent="space-between"
         alignItems={isSidebarGL ? 'flex-start' : 'center'}
         width="100%"
         height={theme.tmpHeadingBlockHeight}
         paddingVertical={theme.tmpSpacingTop}
         borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
         {children}
      </View>
   )
}

Titlebar.propTypes = {
   children: PropTypes.node.isRequired
}

export default Titlebar
